import { render } from "./BulkCreditUploadView.vue?vue&type=template&id=38b030e8&scoped=true&ts=true"
import script from "./BulkCreditUploadView.vue?vue&type=script&lang=ts"
export * from "./BulkCreditUploadView.vue?vue&type=script&lang=ts"

import "./BulkCreditUploadView.vue?vue&type=style&index=0&id=38b030e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b030e8"]])

export default __exports__